import React from 'react';

const PreguntaHero = () => {
  return(
    <div>
      <a href="#menuHabitual" className='btn-hero-pregunta'>Hambriento?</a>
    </div>
  )
}

export { PreguntaHero }